import React from "react";



const InstitutionalPlanner = () => {
    const pdfFiles = [
        { name: 'Institutional Planner Primary, HGS school Bhopal ', url: '../newdocuments/Institutional Planner H.G. Bhopal.docx'},
        { name: 'Institutional Planner Senior, HGS school Bhopal', url: '../newdocuments/Institutional Planner H.G. Bhopal.docx'},
        { name: 'Institutional Planner, HGS school Bhimtal', url: '../disclosure2026/Institutional Planner Template 2026 (1).docx'},
        { name: 'Institutional Planner, HGS school Anangpur', url: '../newdocuments/2904/institutional Planner 2026-27 (1).docx'},
        { name: 'Institutional Planner, HGS school Palla Nuh', url: '../newdocuments/1205/Institutional Planner Nuh.docx'},
        { name: 'Institutional Planner, HGS school Varansi', url: '../newdocuments/2904/Institutional Planner H.G. Varanasi (1) (1).docx'},
        { name: 'Institutional Planner, HGS school Jammu', url: '../newdocuments/0805/Institutional Planner jammu.docx'},
        { name: 'Institutional Planner, HGS school Faridabad', url: '../newdocuments/HGS Institutional planner 26-27 with Examination.docx'},
      ];
 
  return (
    <div className="home_main">
      <div className="pdf-container">
      <table className="pdf-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Filename</th>
            <th>Link To Documents</th>
          </tr>
        </thead>
        <tbody>
          {pdfFiles.map((file, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{file.name}</td>
              <td>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  View
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

      
    </div>
  );
};

export default InstitutionalPlanner;
